import React from "react";

// `disc` is the colour behind the mark. The PNG carries a black field that
// mixBlendMode:screen knocks out, so the backing has to stay dark -- but when it
// was fixed at chocolate the eagle sat inside a visible dark circle on every
// header that wasn't chocolate. Callers pass their own surface colour so the
// disc disappears into it.
export function EagleLogo({ className = "h-10 w-10", disc = "bg-brand-charcoal" }) {
    return (
        <div className={`${className} rounded-full overflow-hidden ${disc} flex-shrink-0`} aria-hidden="true">
            <img
                src="/eagle-icon.png"
                alt=""
                className="w-full h-full object-cover"
                style={{ mixBlendMode: "screen" }}
            />
        </div>
    );
}
